var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H14.2C18.6804 0 20.9206 0 22.6319 0.871948C24.1372 1.63893 25.3611 2.86278 26.1281 4.36808C27 6.07937 27 8.31958 27 12.8V14.2C27 18.6804 27 20.9206 26.1281 22.6319C25.3611 24.1372 24.1372 25.3611 22.6319 26.1281C20.9206 27 18.6804 27 14.2 27H12.8C8.31958 27 6.07937 27 4.36808 26.1281C2.86278 25.3611 1.63893 24.1372 0.871948 22.6319C0 20.9206 0 18.6804 0 14.2V12.8Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.5H6.5C5.95 18.5 5.5 18.95 5.5 19.5C5.5 20.05 5.95 20.5 6.5 20.5H14.5C15.05 20.5 15.5 20.05 15.5 19.5C15.5 18.95 15.05 18.5 14.5 18.5ZM20.5 10.5H6.5C5.95 10.5 5.5 10.95 5.5 11.5C5.5 12.05 5.95 12.5 6.5 12.5H20.5C21.05 12.5 21.5 12.05 21.5 11.5C21.5 10.95 21.05 10.5 20.5 10.5ZM6.5 16.5H20.5C21.05 16.5 21.5 16.05 21.5 15.5C21.5 14.95 21.05 14.5 20.5 14.5H6.5C5.95 14.5 5.5 14.95 5.5 15.5C5.5 16.05 5.95 16.5 6.5 16.5ZM5.5 7.5C5.5 8.05 5.95 8.5 6.5 8.5H20.5C21.05 8.5 21.5 8.05 21.5 7.5C21.5 6.95 21.05 6.5 20.5 6.5H6.5C5.95 6.5 5.5 6.95 5.5 7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingIcon);
export default __webpack_public_path__ + "static/media/reading_icon.febf3da6c40fb72f206813951373f359.svg";
export { ForwardRef as ReactComponent };